import React from 'react';
import Image from 'next/image';

const CarrerMoweb = () => {
    return (
        <div className="section dark:bg-black section-py lg:pb-5">
            <div className="container lg:container mx-auto">
                <div className="row grid xl:grid-cols-1 lg:grid-cols-1 md:grid-cols-1">
                    <h2 className="mb-50">Life at Moweb Limited</h2>
                </div>
                <div className="moweb-life-main">
                    <div className="moweb-life-box">
                        <ul className="moweb-life-items mb-0">
                            <li className="moweb-life-items_item">
                                <div>
                                    <Image
                                        src="/img/career/img-tour@2x.webp"
                                        width={290}
                                        height={396}
                                        alt="moweb-tour"
                                        title="moweb-tour"
                                        loading="lazy"
                                    />
                                </div>
                            </li>
                            <li className="moweb-life-items_item">
                                <div>
                                    <Image
                                        src="/img/career/img-game@2x.webp"
                                        width={240}
                                        height={236}
                                        alt="Moweb Cricket Match"
                                        title="Moweb Cricket Match"
                                    />
                                </div>
                            </li>
                            <li className="moweb-life-items_item">
                                <div>
                                    <Image
                                        src="/img/career/img-birthday@2x.webp"
                                        width={400}
                                        height={276}
                                        alt="Birthday Celebration"
                                        title="Birthday Celebration"
                                    />
                                </div>
                            </li>
                            <li className="moweb-life-items_item">
                                <div>
                                    <Image
                                        src="/img/career/img-team@2x.webp"
                                        width={530}
                                        height={314}
                                        alt="Moweb Team"
                                        title="Moweb Team"
                                    />
                                </div>
                            </li>
                            <li className="moweb-life-items_item">
                                <div>
                                    <Image
                                        src="/img/career/img-appreciate@2x.webp"
                                        width={400}
                                        height={290}
                                        alt="Team Appreciation"
                                        title="Team Appreciation"
                                    />
                                </div>
                            </li>
                            <li className="moweb-life-items_item">
                                <div>
                                    <Image
                                        src="/img/career/img-moweb.webp"
                                        width={400}
                                        height={293}
                                        alt="Moweb Team Members"
                                        title="Moweb Team Members"
                                    />
                                </div>
                            </li>
                        </ul>
                        <ul className="moweb-life-titles mb-0">
                            <li className="moweb-life-titles_title fw-700 fs-xl">Innovative</li>
                            <li className="moweb-life-titles_title fw-700 fs-xl">Positive</li>
                        </ul>
                        <div className="line-wrap">
                            <div className="line-1">
                                <Image
                                    src="/img/career/img-bottom@2x.webp"
                                    width={180}
                                    height={30}
                                    alt="img-girl"
                                    title="img-girl"
                                />
                            </div>
                            <div className="line-2">
                                <Image
                                    src="/img/career/img-top@2x.webp"
                                    width={180}
                                    height={40}
                                    alt="img-girl"
                                    title="img-girl"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CarrerMoweb;
